import { type ChangeEvent, memo, useCallback, useId } from 'react';

import {
  FIELD_VALUE_MAX_LENGTH,
  workspaceAgentFormInput,
} from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentFormInput';

export type WorkspaceAgentFieldSpec = {
  label: string;
  placeholder?: string;
};

export type WorkspaceAgentFieldInputProps = {
  field: WorkspaceAgentFieldSpec;
  onChange: (label: string, value: string) => void;
  value: string;
};

export const WorkspaceAgentFieldInput = memo(({ field, onChange, value }: WorkspaceAgentFieldInputProps) => {
  const inputId = useId();
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(field.label, event.target.value);
    },
    [field.label, onChange],
  );

  return (
    <label className="flex flex-col gap-1 font-medium text-12 text-gray-11 leading-4" htmlFor={inputId}>
      {field.label}
      <input
        aria-label={field.label}
        id={inputId}
        className={workspaceAgentFormInput()}
        maxLength={FIELD_VALUE_MAX_LENGTH}
        onChange={handleChange}
        placeholder={field.placeholder}
        value={value}
      />
    </label>
  );
});

WorkspaceAgentFieldInput.displayName = 'WorkspaceAgentFieldInput';
